/* eslint-disable @typescript-eslint/unbound-method */
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import type { CreditDataType } from './types';

export const creditAdapter = createEntityAdapter<CreditDataType, CreditDataType['carId']>(
  {
    selectId: credit => credit.carId,
  },
);

export const creditSlice = createSlice({
  name: 'credit',
  initialState: creditAdapter.getInitialState(),
  reducers: {
    addCredit: creditAdapter.setOne,
    removeCredit: creditAdapter.removeOne,
  },
});

export default creditSlice.reducer;
